import React from 'react';

interface TarjetaResumenProps {
  titulo: string;
  valor: string | number;
  subtitulo?: string;
  icon?: React.ReactNode;
  color?: 'blue' | 'green' | 'red' | 'amber' | 'purple';
}

const colorMap = {
  blue: 'bg-blue-50 border-blue-200 text-blue-700',
  green: 'bg-green-50 border-green-200 text-green-700',
  red: 'bg-red-50 border-red-200 text-red-700',
  amber: 'bg-amber-50 border-amber-200 text-amber-700',
  purple: 'bg-purple-50 border-purple-200 text-purple-700',
};

const colorIconMap = {
  blue: 'text-blue-500',
  green: 'text-green-500',
  red: 'text-red-500',
  amber: 'text-amber-500',
  purple: 'text-purple-500',
};

export const TarjetaResumen: React.FC<TarjetaResumenProps> = ({
  titulo,
  valor,
  subtitulo,
  icon,
  color = 'blue',
}) => {
  return (
    <div
      className={`p-6 rounded-lg border-2 ${colorMap[color]} shadow-sm hover:shadow-md transition-shadow`}
    >
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-600 mb-2">{titulo}</p>
          <p className="text-3xl font-bold text-gray-900 mb-1">{valor}</p>
          {subtitulo && (
            <p className="text-xs text-gray-500">{subtitulo}</p>
          )}
        </div>
        {icon && (
          <div className={`ml-4 ${colorIconMap[color]}`}>
            {icon}
          </div>
        )}
      </div>
    </div>
  );
};
